import GAListener from "./pages/GAListener";
import PageSpinner from "./pages/PageSpinner";
import React from "react";
import componentQueries from "react-component-queries";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "./styles/reduction.scss";

const DistrictComponent = React.lazy(() =>
    import("../../TabComponent/district")
);
const WardComponent = React.lazy(() => import("../../TabComponent/ward"));
const PalikaComponent = React.lazy(() => import("../../TabComponent/palika"));
const DashboardPage = React.lazy(() => import("./pages/Homepage"));
const PersonalProfile = React.lazy(() => import("./pages/PersonalProfile"));
const Vaccination = React.lazy(() => import("./pages/Vaccination"));
const Household = React.lazy(() => import("./pages/HouseHold"));

const Sakhuwa = React.lazy(() =>
    import("./pagecomponents/ParsaMunicipalities/Sakhuwa")
);

const Population = React.lazy(() => import("./pages/Population"));
const ProvinceTwo = React.lazy(() => import("./pages/ProvinceTwo"));
const MunicipalityTable = React.lazy(() => import("./pages/MunicipalityTable"));
const PopulationData = React.lazy(() => import("./pages/PopulationData"));
const Householddata = React.lazy(() =>
    import("./pagecomponents/HouseHoldData/Householddata")
);
const HealthData = React.lazy(() =>
    import("./pagecomponents/HealthData/HealthData")
);
const vaccinationData = React.lazy(() =>
    import("./pagecomponents/Vaccination Data/vaccinationData")
);
const MunicipalitySearch = React.lazy(() =>
    import("../../../pagecomponents/WardPortal1/components/WardSearch")
);
const getBasename = () => {
    return `/${process.env.PUBLIC_URL.split("/").pop()}`;
};
class App extends React.Component {
    render() {
        return (
            <BrowserRouter basename={getBasename()}>
                <GAListener>
                    <Switch>
                        <React.Suspense fallback={<PageSpinner />}>
                            {/* <Route exact path="/" component={DashboardPage} /> */}
                            <Route
                                exact
                                path="/personal"
                                component={PersonalProfile}
                            />
                            <Route
                                exact
                                path="/vaccination"
                                component={Vaccination}
                            />
                            <Route
                                exact
                                path="/vaccinationdata"
                                component={vaccinationData}
                            />
                            <Route
                                exact
                                path="/household"
                                component={Household}
                            />
                            <Route
                                exact
                                path="/householddata"
                                component={Householddata}
                            />
                            {/* <Route exact path="/health" component={Health} /> */}
                            <Route
                                exact
                                path="/healthdata"
                                component={HealthData}
                            />
                            <Route
                                exact
                                path="/profile"
                                component={MunicipalitySearch}
                            />
                            <Route
                                exact
                                path="/personaltable"
                                component={MunicipalityTable}
                            />
                            <Route
                                exact
                                path="/populationdata"
                                component={PopulationData}
                            />
                            <Route
                                exact
                                path="/population"
                                component={Population}
                            />
                            <Route
                                exact
                                path="/provincetwo"
                                component={ProvinceTwo}
                            />
                            <Route
                                exact
                                path="/ward"
                                component={WardComponent}
                            />
                            <Route
                                exact
                                path={"/parsa/:district"}
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/bara/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/rautahat/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/sarlahi/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/mahottari/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/dhanusha/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/siraha/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/saptari/:district"
                                component={DistrictComponent}
                            />
                            <Route
                                exact
                                path="/parsa/:district/sakhuwa/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/parsa/:district/kalikamai/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/parsa/:district/thori/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/bara/:district/pachrauta/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/bara/:district/karaiyamai/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/bara/:district/pheta/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/rautahat/:district/chandrapur/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/rautahat/:district/gaur/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/rautahat/:district/durgabhagawati/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/sarlahi/:district/ishworpur/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/sarlahi/:district/chandranagar/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/sarlahi/:district/godaita/:palikaId"
                                component={PalikaComponent}
                            />

                            <Route
                                exact
                                path="/mahottari/:district/bardibas/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/mahottari/:district/mahottari/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/mahottari/:district/ekdara/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/dhanusha/:district/mithila/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/dhanusha/:district/bateshwor/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/dhanusha/:district/shahidnagar/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/siraha/:district/dhangadhimai/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/siraha/:district/arnama/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/siraha/:district/aurahi/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/saptari/:district/hanumannagar/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/saptari/:district/tilathi/:palikaId"
                                component={PalikaComponent}
                            />
                            <Route
                                exact
                                path="/saptari/:district/kanchanrup/:palikaId"
                                component={PalikaComponent}
                            />
                        </React.Suspense>
                        {/* <Redirect to="/" /> */}
                    </Switch>
                </GAListener>
            </BrowserRouter>
        );
    }
}
const query = ({ width }) => {
    if (width < 575) {
        return { breakpoint: "xs" };
    }

    if (576 < width && width < 767) {
        return { breakpoint: "sm" };
    }

    if (768 < width && width < 991) {
        return { breakpoint: "md" };
    }

    if (992 < width && width < 1199) {
        return { breakpoint: "lg" };
    }

    if (width > 1200) {
        return { breakpoint: "xl" };
    }

    return { breakpoint: "xs" };
};
export default componentQueries(query)(App);
